(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/components/transcript-ordered-download.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/components/transcript-ordered-download.js');
'use strict';

const downloadUrlBase = svs.core.jupiter.url();
const Icon = svs.ui.ReactIcon;

const TranscriptOrderedDownload = _ref => {
  let {
    transcript,
    transcriptType
  } = _ref;
  const isNativeApp = svs.core.config.data.svsconfig.isNativeApp;
  const myProfileHomeUrl = svs.core.urlMapping.get('myProfileHome');
  const zipUrl = transcriptType => {
    switch (transcriptType) {
      case 'Registerutdrag':
        return 'Registerutdrag.zip';
      case 'Mina spel':
        return 'Mina-spel-Utdrag.zip';
      case 'Kontohistorik':
        return 'Kontohistorik-Utdrag.zip';
      default:
        break;
    }
  };
  const appDownloadUrl = "".concat(myProfileHomeUrl, "/ladda-ner-din-data/").concat(transcript.OrderId, "/").concat(zipUrl(transcriptType));
  const webDownloadUrl = "".concat(downloadUrlBase, "/minc-proxy/v1/transcript/").concat(transcript.OrderId);
  const convertToDate = string => dateFns.format(new Date(string), 'yyyy-MM-dd', {
    locale: dateFns.locales.sv
  });
  return React.createElement("a", {
    className: "u-flex",
    href: isNativeApp ? appDownloadUrl : webDownloadUrl
  }, React.createElement("span", {
    className: "u-flex-grow-1 u-block u-text-decoration-underline"
  }, transcriptType), React.createElement("span", {
    className: "u-flex-grow-1 u-block u-text-decoration-none fc-navy"
  }, "Best\xE4llt:", ' ', convertToDate(transcript.OrderDate)), React.createElement("span", {
    className: "u-flex-shrink-1 u-text-decoration-none padding-h fc-navy"
  }, ".ZIP"), React.createElement("span", {
    className: "u-flex-shrink-1 padding-h"
  }, React.createElement(Icon, {
    className: "u-align-middle",
    icon: "document",
    size: "200"
  })));
};
svs.myProfile.react.pages.myInformation.transcript.transcript.TranscriptOrderedDownload = TranscriptOrderedDownload;

 })(window);